export default __webpack_public_path__ + "static/media/mars2.6cae79d3.png";